import styled from "styled-components"

export const WidgetsRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;

  > div {
    flex: 1 0 320px;
    min-width: 0;
    margin-bottom: 0;
  }
`
